import { useState, useEffect } from "react";

// Router
import { NavLink, withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import useIncomeInterestReport from "../../custom-hooks/useIncomeInterestReport";
import { showModal } from "../../redux/actions/modal";

// UI Components
import ButtonLoader, { Loader } from "../../UI/Loaders/Loaders";
import Paginator from "../Pagination/Pagination.component";

import { BASE_URL } from "../../appConstants";
import { getTokenFromLocalStorage } from "../../helpers/localStorage";
import { formatMoney } from "../../helpers/formatter";
import { appInsights } from "../../config/appInsights";

const today = new Date().toISOString().slice(0, 10);
const lastMonth = new Date(new Date());
lastMonth.setDate(lastMonth.getDate() - 30);
const aMonthAgo = lastMonth.toISOString().slice(0, 10);

const IncomeInterestReport = (props) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [count, setCount] = useState(null);
  // const [size, setSize] = useState(10);

  const [startDate, setStartDate] = useState(aMonthAgo);
  const [endDate, setEndDate] = useState(today);
  const [date, setDate] = useState({
    StartDate: aMonthAgo,
    EndDate: today,
  });

  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    appInsights.trackPageView({
      name: "Income Interest Report - (IncomeInterestReport.js)",
      isLoggedIn: true,
    });
  }, []);

  //  Methods
  const modalHandler = (modalData, type) => {
    props.showModal({
      modalIdentifier: "audittrail",
      dataRecord: modalData,
      action: "customrange",
      type,
    });
  };
  const handleDownload = () => {
    setDownloadLoading(true);

    let token = getTokenFromLocalStorage();
    let queryParams = "";
    if (startDate && endDate) {
      queryParams = `?StartDate=${startDate}&EndDate=${endDate}`;
    }

    fetch(BASE_URL + `/eco/gl_report/csv${queryParams}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: "Token " + token,
      },
      // body: JSON.stringify(data)
    })
      .then((response) => {
        setDownloadLoading(false);

        if (response.status === 200 || response.status === 201) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${
                startDate && endDate
                  ? `IncomeInterestReport from ${startDate} to ${endDate}.csv`
                  : `Income_Interest_Report.csv`
              }`
            );
            link.click();
          });
        }

        if (response.status === 403 || response.status === 401) {
          localStorage.removeItem("sso_auth_token");
          this.props.history.push("/login");
        }

        if (response.status >= 500) {
          // this.setState({ error: "Something went wrong. Please check your internet connection and try again" });
        }
      })
      .catch(() => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "IncomeInterestReport.jsx",
          },
        });
        // this.setState({ loading: false, error: "Something went wrong. Please check your internet connection and try again" });
        setDownloadLoading(false);
      });
  };
  const resetTable = () => {
    setCount(null);
    setPageNumber(1);
  };

  const filterData = (e) => {
    e.preventDefault();

    const diffTime = new Date(endDate) - new Date(startDate);
    if (diffTime < 0) {
      modalHandler("", "alert");
      return;
    }

    resetTable();
    setDate({
      StartDate: startDate,
      EndDate: endDate,
    });
  };

  //  Life Cycle Hooks
  useEffect(() => {
    //  If user is not authenticates, redirect to login
    if (!props.isAuthenticated) {
      props.history.push("/login");
    }
  }, [props.history, props.isAuthenticated, props.loggedInUser]);

  //JSX Template
  let RenderedComponent = null;

  const { data, status, error } = useIncomeInterestReport({
    StartDate: date.StartDate,
    EndDate: date.EndDate,
    // Page: pageNumber,
    // PageSize: size,
  });

  // if (data) {
  //   if (count === null) {
  //     setCount(data.totalCount);
  //   }
  // }

  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Repayment Reports
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered="true" text="Loading Repayment Reports..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              interest income reports, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (!data?.data?.data?.length || !data?.data?.data) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no logged
              activities.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive ">
            <h4>Summary</h4>
            <table className="table mt-4">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>Currency Code</th>
                  <th>Total Debit</th>
                  <th>Total Credit</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.sum?.map((request, _id) => {
                  const { currencyCode, totalDebit, totalCredit, balance } =
                    request;
                  return (
                    <tr key={_id}>
                      <td>{currencyCode}</td>
                      <td>
                        {totalDebit ? formatMoney(totalDebit) : totalDebit}
                      </td>
                      <td>
                        {totalCredit ? formatMoney(totalCredit) : totalCredit}
                      </td>
                      <td>{balance ? formatMoney(balance) : balance}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <h4 className="mt-4">GL Details</h4>
            <table className="table mt-4 ">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>GL Name</th>
                  <th>GL Code</th>
                  <th>Currency Code</th>
                  <th>Total Debit</th>
                  <th>Total Credit</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.data?.map((request, _id) => {
                  const {
                    glName,
                    glCode,
                    currencyCode,
                    totalDebit,
                    totalCredit,
                    balance,
                  } = request;
                  return (
                    <tr key={_id}>
                      <td>{glName}</td>
                      <td>{glCode}</td>
                      <td>{currencyCode}</td>
                      <td>
                        {totalDebit ? formatMoney(totalDebit) : totalDebit}
                      </td>
                      <td>
                        {totalCredit ? formatMoney(totalCredit) : totalCredit}
                      </td>
                      <td>{balance ? formatMoney(balance) : balance}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x fadeInRight">
        {/*Repayment Reports Header*/}
        <div className="block-header">
          <div className="row">
            <div className="col-lg-8 col-md-6 col-sm-12 dashboard-title flex__row">
              {/* <h3 className="m-l-1">
                <aside className="rounder">1</aside>
                &nbsp; Reports
              </h3> */}

              <div className="breadcrumb__location  ">
                <NavLink to="dashboard">
                  <h3 className="breadcrumb__location__title">Dashboard</h3>
                </NavLink>
                <span className="breadcrumb__location__icon">
                  <i className="fas fa-angle-double-right" />
                </span>
                <NavLink to="/loan-income-interest-reports">
                  <h3 className="breadcrumb__location__title">
                    Loan Income Interest Report
                  </h3>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="d-flex flex-row flex-wrap ">
            {/* <div className="d-flex flex-row flex-wrap justify-content-start m-l-1 m-t-1">
              <label htmlFor="table-fetch" className="form-group">
                Number of results:{" "}
                <select
                  onChange={(e) => {
                    resetTable();
                    setSize(e.target.value);
                  }}
                  id="table-fetch"
                  className="table-fetch-select m-l-1"
                  value={size}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </label>
            </div> */}

            <form className="d-flex flex-row m-t-md" onSubmit={filterData}>
              <div
                className="d-flex flex-row flex-wrap justify-content-start"
                style={{ alignItems: "flex-end" }}
              >
                <div className="m-l-1 m-r-1 m-b-1 form-group">
                  <label htmlFor="table-fetch">Start Date:</label>
                  <input
                    type="date"
                    className="form-control"
                    defaultValue={aMonthAgo}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>

                <div className="m-l-1 m-r-1 m-b-1 form-group">
                  <label htmlFor="table-fetch">End Date:</label>
                  <input
                    type="date"
                    className="form-control"
                    defaultValue={today}
                    max={today}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <button
                  className="m-l-1 m-r-1 zoom-element btn login-btn"
                  type="submit"
                  value="submit"
                >
                  Search
                </button>
                {/* Start of download button */}
                <button
                  type="button"
                  className="btn advancly-white-btn  "
                  onClick={handleDownload}
                  disabled={status === "loading" || downloadLoading}
                >
                  <i className="fas fa-download m-r-1" />
                  Download {downloadLoading && <ButtonLoader />}
                </button>

                {/* end of download button */}
              </div>
            </form>
          </div>
        </div>

        {/*Datatable || Loader || Error Message*/}
        {RenderedComponent}

        <Paginator
          // size={size}
          page={pageNumber}
          count={count}
          changeCurrentPage={(pageNumber) => setPageNumber(pageNumber)}

          //testing
          //   size={search.PageSize}
          //     page={search.Page}
          //     count={count}
          //     changeCurrentPage={(Page) => setSearch({ ...search, Page })}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    authReducer: { isAuthenticated, loggedInUser },
  } = state;

  return {
    isAuthenticated,
    loggedInUser,
  };
};

export default withRouter(
  connect(mapStateToProps, { showModal })(IncomeInterestReport)
);
